/* eslint-disable sonarjs/no-duplicate-string */

import { Device, Envs, Markets, Systems } from 'scbk-services/config/enums';
import { CommonConfigType } from 'scbk-services/types/config/config-types';

export const commonConfig: CommonConfigType = {
    /**
     * experience API
     */
    expDomain: {
        value: 'https://ma4sb.sc.co.kr',
        system: {
            [Systems.AZURE]: {
                env: {
                    [Envs.LOCAL]: '',
                    [Envs.DEV]: 'https://maut-ng.sc.co.kr',
                    [Envs.SIT]: 'https://masit-ng.sc.co.kr',
                    [Envs.UAT]: 'https://mauat-ng.sc.co.kr',
                    [Envs.PROD]: 'https://ma-ng.sc.co.kr',
                },
            },
            [Systems.DEV_FACTORY]: {
                env: {
                    [Envs.LOCAL]: '',
                    [Envs.DEV]: 'https://masb-devut.sc.co.kr',
                    [Envs.SIT]: 'https://masb-devsit.sc.co.kr',
                    [Envs.UAT]: 'https://masb-devuat.sc.co.kr',
                    [Envs.PROD]: 'https://ma4sb.sc.co.kr',
                },
            },
            [Systems.SKE]: {
                env: {
                    [Envs.LOCAL]: '',
                    [Envs.DEV]: 'https://maske-devut.sc.co.kr',
                    [Envs.SIT]: 'https://maske-devsit.sc.co.kr',
                    [Envs.UAT]: 'https://maske-devuat.sc.co.kr',
                    [Envs.PROD]: 'https://ma4ske.sc.co.kr',
                },
            },
        },
    },
    expContextPath: {
        value: '',
        markets: {
            [Markets.KR]: {
                value: '/retail/api/v1',
                env: {
                    [Envs.LOCAL]: '/local',
                    [Envs.DEV]: '/retail/api/v1',
                },
            },
        },
    },
    expEnvironmentPath: {
        value: '',
        markets: {
            [Markets.KR]: {
                value: '',
                env: {
                    [Envs.STAGING]: '',
                },
            },
        },
    },

    /**
     * BSOI
     */
    bsoiDomain: {
        value: 'https://ma4sb.sc.co.kr',
        system: {
            [Systems.AZURE]: {
                env: {
                    [Envs.LOCAL]: '',
                    [Envs.DEV]: 'https://maut-ng.sc.co.kr',
                    [Envs.SIT]: 'https://masit-ng.sc.co.kr',
                    [Envs.UAT]: 'https://mauat-ng.sc.co.kr',
                    [Envs.PROD]: 'https://ma-ng.sc.co.kr',
                },
            },
            [Systems.DEV_FACTORY]: {
                env: {
                    [Envs.LOCAL]: '',
                    [Envs.DEV]: 'https://masb-devut.sc.co.kr',
                    [Envs.SIT]: 'https://masb-devsit.sc.co.kr',
                    [Envs.UAT]: 'https://masb-devuat.sc.co.kr',
                    [Envs.PROD]: 'https://ma4sb.sc.co.kr',
                },
            },
            [Systems.SKE]: {
                env: {
                    [Envs.LOCAL]: '',
                    [Envs.DEV]: 'https://maske-devut.sc.co.kr',
                    [Envs.SIT]: 'https://maske-devsit.sc.co.kr',
                    [Envs.UAT]: 'https://maske-devuat.sc.co.kr',
                    [Envs.PROD]: 'https://ma4ske.sc.co.kr',
                },
            },
        },
    },
    bsoiContextPath: {
        value: '',
        markets: {
            [Markets.KR]: {
                value: '/bsoi/commons',
                env: {
                    [Envs.LOCAL]: '/bsoi/commons',
                    [Envs.DEV]: '/bsoi/commons',
                },
            },
        },
    },

    // JWT (JWT) 사용모드  (NONE, KONG, INTERNAL)
    jwtUseMode: {
        value: 'NONE',
        system: {
            [Systems.AZURE]: {
                env: {
                    [Envs.LOCAL]: 'NONE',
                    [Envs.DEV]: 'NONE',
                    [Envs.SIT]: 'NONE',
                    [Envs.UAT]: 'NONE',
                },
            },
            [Systems.DEV_FACTORY]: {
                env: {
                    [Envs.LOCAL]: 'NONE',
                    [Envs.DEV]: 'KONG',
                    [Envs.SIT]: 'NONE',
                    [Envs.UAT]: 'NONE',
                },
            },
            [Systems.SKE]: {
                env: {
                    [Envs.LOCAL]: 'NONE',
                    [Envs.DEV]: 'NONE',
                    [Envs.SIT]: 'NONE',
                    [Envs.UAT]: 'NONE',
                },
            },
        },
    },

    /**
     * KONG
     */
    kongDomain: {
        value: 'https://api-ng.sc.co.kr',
        env: {
            [Envs.LOCAL]: '',
            [Envs.DEV]: 'https://api-ng-ut.sc.co.kr',
        },
    },
    kongContextPath: {
        value: '',
        markets: {
            [Markets.KR]: {
                value: '/retail/api/v1',
                env: {
                    [Envs.LOCAL]: '/local',
                    [Envs.DEV]: '/retail/api/v1',
                },
            },
        },
    },

    googlePlayStoreHome: {
        value: '',
        markets: {
            [Markets.KR]: {
                value: 'https://play.google.com/store/apps/details?id=com.scbank.ma30',
            },
        },
    },
    appleAppStoreHome: {
        value: '',
        markets: {
            [Markets.KR]: {
                value: 'https://itunes.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=1457418899',
            },
        },
    },

    language: {
        value: 'ko',
    },
    availableMarkets: {
        value: `${Markets.KR}`,
    },
    availableEnvs: {
        value: `${Envs.MOCK},${Envs.LOCAL},${Envs.DEV}`,
        markets: {
            [Markets.KR]: {
                value: `${Envs.MOCK},${Envs.LOCAL},${Envs.DEV}`,
            },
        },
    },
    platform: {
        value: 'IB', // 기본값: PC용
        devices: {
            [Device.PC]: 'IB',
            [Device.MOBILE]: 'SB',
            [Device.TABLET]: 'SB',
        },
    },

    // 금융인증서
    finCertOrgCode: {
        value: 'RB00230000',
        env: {
            [Envs.LOCAL]: 'DB00230000',
            [Envs.DEV]: 'DB00230000',
            [Envs.SIT]: 'D200900005',
            [Envs.UAT]: 'D200900005',
            [Envs.PT]: 'D200900005',
            [Envs.OAT]: 'D200900005',
            [Envs.STAGING]: 'D200900005',
            [Envs.PROD]: 'RB00230000',
        },
    },
    finCertApiKey: {
        value: '4b95ffb7-64ab-4063-9235-6d8e9ca01f55',
        env: {
            [Envs.LOCAL]: 'ad61d665-46ec-4e5d-9a9f-9ef272ca25ed',
            [Envs.DEV]: 'ad61d665-46ec-4e5d-9a9f-9ef272ca25ed',
            [Envs.SIT]: 'ad61d665-46ec-4e5d-9a9f-9ef272ca25ed',
            [Envs.UAT]: 'ad61d665-46ec-4e5d-9a9f-9ef272ca25ed',
            [Envs.PT]: 'ad61d665-46ec-4e5d-9a9f-9ef272ca25ed',
            [Envs.OAT]: 'ad61d665-46ec-4e5d-9a9f-9ef272ca25ed',
            [Envs.STAGING]: 'ad61d665-46ec-4e5d-9a9f-9ef272ca25ed',
            [Envs.PROD]: '4b95ffb7-64ab-4063-9235-6d8e9ca01f55',
        },
    },
    // FINTECH_MA30_DOMAIN
    finCertScbkDomain: {
        value: 'https://maut-ng.sc.co.kr',
        env: {
            [Envs.LOCAL]: 'https://maut-ng.sc.co.kr',
            [Envs.DEV]: 'https://maut-ng.sc.co.kr',
            [Envs.SIT]: 'https://maut-ng.sc.co.kr',
            [Envs.UAT]: 'https://maut-ng.sc.co.kr',
            [Envs.PT]: 'https://maut-ng.sc.co.kr',
            [Envs.OAT]: 'https://maut-ng.sc.co.kr',
            [Envs.STAGING]: 'https://maut-ng.sc.co.kr',
            [Envs.PROD]: 'https://maut-ng.sc.co.kr',
        },
    },
    finCertClientOrigin: {
        value: 'com.scbank.ma30',
    },
    finCertClientCssUrl: {
        value: '/css/finCertSdk.css',
    },
    finCertSdkJsUrl: {
        value: 'https://4user.yeskey.or.kr/v1/fincert.js',
        env: {
            [Envs.LOCAL]: 'https://t-4user.yeskey.or.kr/v1/fincert.js',
            [Envs.DEV]: 'https://t-4user.yeskey.or.kr/v1/fincert.js',
            [Envs.SIT]: 'https://t-4user.yeskey.or.kr/v1/fincert.js',
            [Envs.UAT]: 'https://t-4user.yeskey.or.kr/v1/fincert.js',
            [Envs.PT]: 'https://t-4user.yeskey.or.kr/v1/fincert.js',
            [Envs.OAT]: 'https://t-4user.yeskey.or.kr/v1/fincert.js',
            [Envs.STAGING]: 'https://t-4user.yeskey.or.kr/v1/fincert.js',
            [Envs.PROD]: 'https://4user.yeskey.or.kr/v1/fincert.js',
        },
    },

    /**
     * CLIP
     */
    clipUrl: {
        value: 'https://ma4clip.sc.co.kr',
        system: {
            [Systems.AZURE]: {
                env: {
                    [Envs.LOCAL]: '/local',
                    [Envs.DEV]: 'https://clip-ut.standardchartered.co.kr',
                    [Envs.SIT]: 'https://clip-ut.standardchartered.co.kr',
                    [Envs.UAT]: 'https://clip-ut.standardchartered.co.kr',
                    [Envs.PROD]: 'https://ma4clip.sc.co.kr',
                },
            },
            [Systems.DEV_FACTORY]: {
                env: {
                    [Envs.LOCAL]: 'NONE',
                    [Envs.DEV]: 'https://clip-devut.standardchartered.co.kr',
                    [Envs.SIT]: 'https://clip-devsit.standardchartered.co.kr',
                    [Envs.UAT]: 'https://clip-devuat.standardchartered.co.kr',
                    [Envs.PROD]: 'https://ma4clip.sc.co.kr',
                },
            },
            [Systems.SKE]: {
                env: {
                    [Envs.LOCAL]: 'NONE',
                    [Envs.DEV]: 'https://clip-devut.standardchartered.co.kr',
                    [Envs.SIT]: 'https://clip-devsit.standardchartered.co.kr',
                    [Envs.UAT]: 'https://clip-devuat.standardchartered.co.kr',
                    [Envs.PROD]: 'https://ma4clip.sc.co.kr',
                },
            },
        },
    },
    clipJsPath: {
        value: '/clip/js/clipreport5.js',
    },
    clipUserConfigJsPath: {
        value: '/clip/js/UserConfig5.js',
    },
    clipOOFDocumentJsPath: {
        value: '/clip/js/oof/OOFDocument.js',
    },
    clipCssPath: {
        value: '/clip/css/clipreport5.css',
    },
    clipUserConfigCssPath: {
        value: '/clip/css/UserConfig5.css',
    },
    clipFontCssPath: {
        value: '/clip/css/font.css',
    },
    // signGate success return URL
    signGateSucReturnUrl: {
        value: 'https://www.signgate.com/web-interface/bankpay/formPayInfInput.sg',
        env: {
            [Envs.LOCAL]: 'https://dev.signgate.com/web-interface/bankpay/formPayInfInput.sg',
            [Envs.DEV]: 'https://dev.signgate.com/web-interface/bankpay/formPayInfInput.sg',
            [Envs.SIT]: 'https://dev.signgate.com/web-interface/bankpay/formPayInfInput.sg',
            [Envs.UAT]: 'https://dev.signgate.com/web-interface/bankpay/formPayInfInput.sg',
            [Envs.PT]: 'https://dev.signgate.com/web-interface/bankpay/formPayInfInput.sg',
            [Envs.OAT]: 'https://dev.signgate.com/web-interface/bankpay/formPayInfInput.sg',
            [Envs.STAGING]: 'https://dev.signgate.com/web-interface/bankpay/formPayInfInput.sg',
            [Envs.PROD]: 'https://www.signgate.com/web-interface/bankpay/formPayInfInput.sg',
        },
    },
    googleMapKey: {
        value: 'AI_za_SyCAsLiefvXNbTZXetgFrp1L0lrBZkZCZpA',
    },
    // AF appWebId 키 관리
    afWebAppId: {
        value: '47dbd513-347e-4d0a-bbac-1afcf028bdfe',
        system: {
            [Systems.AZURE]: {
                env: {
                    [Envs.LOCAL]: '47dbd513-347e-4d0a-bbac-1afcf028bdfe',
                    [Envs.DEV]: '47dbd513-347e-4d0a-bbac-1afcf028bdfe',
                    [Envs.SIT]: 'bc27174e-5d42-4863-a689-a8b07022be96',
                    [Envs.UAT]: '7f7bd9dd-a7c9-41d6-bed5-4a833c7fb13b',
                    [Envs.PROD]: '95fe240c-d46c-48eb-9f6c-a026250f416a',
                },
            },
            [Systems.DEV_FACTORY]: {
                env: {
                    [Envs.LOCAL]: '488b1a40-6360-4ce7-b3f0-fc71a433a4c9',
                    [Envs.DEV]: '488b1a40-6360-4ce7-b3f0-fc71a433a4c9',
                    [Envs.SIT]: 'c2dcdb95-9826-4d05-aecf-38c848055fe4',
                    [Envs.UAT]: '81e5e0ed-fa02-40f2-9ed2-d1974dc10a6d',
                    [Envs.PROD]: '95fe240c-d46c-48eb-9f6c-a026250f416a',
                },
            },
            [Systems.SKE]: {
                env: {
                    [Envs.LOCAL]: '9f2e8d66-a724-467a-b041-21e7dfacacbd',
                    [Envs.DEV]: '9f2e8d66-a724-467a-b041-21e7dfacacbd',
                    [Envs.SIT]: 'a6796740-4049-447c-bf51-bf33c93dc97a',
                    [Envs.UAT]: 'daa43183-24f9-48e6-9980-0d3d3328825c',
                    [Envs.PROD]: '72b9efe3-a44a-43f6-8c3b-6f0f6810bd8c',
                },
            },
        },
    },
};
